import 'Translation/angularModule';

export default angular.module('FrontRoyal.EmailInput', ['Translation']);
